/*
 * @Description:
 * @Author: mdb
 * @Date: 2023-05-08 14:09:31
 * @LastEditTime: 2023-05-08 14:09:34
 * @LastEditors: mdb
 */
export const mapsEnum = [
  { label: '高德', value: 0 },
  { label: '百度', value: 1 }
]

export const statusEnum = [
  { name: '启用', value: 0, color: '#3FAC46' },
  { name: '停用', value: 1, color: '#DF443B' }
]
